module.exports = __webpack_public_path__ + "img/shopware.8a2ae4ec.svg";